var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChorusRecomIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1889 14.8755V13.2661C34.1889 5.21889 30.97 2 22.9228 2H13.2661C5.21889 2 2 5.21889 2 13.2661V22.9228C2 30.97 5.21889 34.1889 13.2661 34.1889H16.485M23.3573 34.1889C23.6617 34.1889 23.963 34.1289 24.2442 34.0124C24.5254 33.896 24.7809 33.7253 24.9961 33.51C25.2113 33.2948 25.382 33.0393 25.4985 32.7582C25.615 32.477 25.6749 32.1756 25.6749 31.8713C25.6749 31.5669 25.615 31.2655 25.4985 30.9844C25.382 30.7032 25.2113 30.4477 24.9961 30.2325C24.7809 30.0173 24.5254 29.8465 24.2442 29.7301C23.963 29.6136 23.6617 29.5537 23.3573 29.5537C22.7426 29.5537 22.1531 29.7978 21.7185 30.2325C21.2839 30.6671 21.0397 31.2566 21.0397 31.8713C21.0397 32.4859 21.2839 33.0754 21.7185 33.51C22.1531 33.9447 22.7426 34.1889 23.3573 34.1889Z",
    stroke: "#C2C2C2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1889 28.4409V20.3119C34.1889 18.5823 32.9579 18.3373 31.6939 18.6399L26.9501 19.7786C26.0966 19.9804 25.4893 20.5857 25.4893 21.4505V29.839",
    stroke: "#C2C2C2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3591 24.9499L34.1889 22.8793M32.0575 31.579C32.6228 31.579 33.1649 31.3608 33.5646 30.9725C33.9643 30.5842 34.1889 30.0575 34.1889 29.5083C34.1889 28.9591 33.9643 28.4324 33.5646 28.0441C33.1649 27.6558 32.6228 27.4376 32.0575 27.4376C31.4922 27.4376 30.9501 27.6558 30.5504 28.0441C30.1507 28.4324 29.9262 28.9591 29.9262 29.5083C29.9262 30.0575 30.1507 30.5842 30.5504 30.9725C30.9501 31.3608 31.4922 31.579 32.0575 31.579Z",
    stroke: "#C2C2C2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 14.7083V22.2916",
    stroke: "#C2C2C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7083 18.5H22.2916",
    stroke: "#C2C2C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChorusRecomIcon);
export default __webpack_public_path__ + "static/media/chorus_recom_icon.28c47866192e04e2a8e740ac33f5f0c2.svg";
export { ForwardRef as ReactComponent };